class NewFaqs {
    constructor() {
        this.init();
    }

    init() {
        const faqLinks = document.querySelectorAll("[data-new-faq-link]");

        if (faqLinks.length > 1) {
            [...faqLinks].forEach(link => {
                link.addEventListener("click", () => {
                    const linkId = link.getAttribute("data-new-faq-link");
                    const url = link.href.split("#")[1];
                    
                    [...faqLinks].map(item => {
                        if (item.getAttribute("data-new-faq-link") === linkId) {
                            if (!item.classList.contains("active")) {
                                item.classList.add("active")
                            }
                        } else {
                            item.classList.remove("active");
                        }

                        return item;
                    })

                    if (url === "blank" || !url) {
                        document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
                    }
                });
            });
        }

        if (window.innerWidth < 992) {
            this.initStickyMobileMenu();
        }
    }

    initStickyMobileMenu() {
        const headerEl = document.querySelector("[data-new-faq-header]");
        const stickyMenu = document.querySelector("[data-new-faq-sticky]");

        const checkViewPortEl = () => {
            if (stickyMenu) {
                const inViewPort = this.inViewPort(headerEl);
    
                if (inViewPort) {
                    if (stickyMenu.classList.contains("active")) {
                        stickyMenu.classList.remove("active")
                    }
                } else {
                    if (!stickyMenu.classList.contains("active")) {
                        stickyMenu.classList.add("active")
                    }
                }
            }
        }

        checkViewPortEl();

        const debouncedOnScroll = debounce(() => {
            checkViewPortEl();
        }, 10);

        document.addEventListener("scroll", debouncedOnScroll)
    }

    inViewPort(section) {
        const rect = section.getBoundingClientRect();
        const inViewport = rect.top < window.innerHeight && rect.bottom > 0;

        return inViewport
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const faq = new NewFaqs();
})